import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Agent run started (the HTTP stream to the agent opens)',
  name: 'agent_chat_run_started',
  params: [
    {
      description: 'The ID of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the chat thread',
      name: 'thread_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the agent run',
      name: 'run_id',
      required: false,
      type: 'string',
    },
    {
      description:
        'The programmatic transform action name (e.g. removeBackground, editTextOcr); absent for plain chat prompts',
      name: 'action',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
